// extracted by mini-css-extract-plugin
export var screen1 = "screen1-module--screen1--62481";
export var screen1__btnInfo = "screen1-module--screen1__btn-info--0f7f5";
export var screen1__btnInfo__col = "screen1-module--screen1__btn-info__col--966e0";
export var screen1__btnInfo__row = "screen1-module--screen1__btn-info__row--f1d20";
export var screen1__desc = "screen1-module--screen1__desc--31be1";
export var screen1__mainContent = "screen1-module--screen1__main-content--db6dc";
export var screen1__tax = "screen1-module--screen1__tax--22c4a";